/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { consultationContentAdminControllerCreateV1 } from '../fn/consultation-content-admin/consultation-content-admin-controller-create-v-1';
import { ConsultationContentAdminControllerCreateV1$Params } from '../fn/consultation-content-admin/consultation-content-admin-controller-create-v-1';
import { consultationContentAdminControllerDeleteV1 } from '../fn/consultation-content-admin/consultation-content-admin-controller-delete-v-1';
import { ConsultationContentAdminControllerDeleteV1$Params } from '../fn/consultation-content-admin/consultation-content-admin-controller-delete-v-1';
import { consultationContentAdminControllerFindAllV1 } from '../fn/consultation-content-admin/consultation-content-admin-controller-find-all-v-1';
import { ConsultationContentAdminControllerFindAllV1$Params } from '../fn/consultation-content-admin/consultation-content-admin-controller-find-all-v-1';
import { consultationContentAdminControllerFindByIdV1 } from '../fn/consultation-content-admin/consultation-content-admin-controller-find-by-id-v-1';
import { ConsultationContentAdminControllerFindByIdV1$Params } from '../fn/consultation-content-admin/consultation-content-admin-controller-find-by-id-v-1';
import { consultationContentAdminControllerReorderV1 } from '../fn/consultation-content-admin/consultation-content-admin-controller-reorder-v-1';
import { ConsultationContentAdminControllerReorderV1$Params } from '../fn/consultation-content-admin/consultation-content-admin-controller-reorder-v-1';
import { consultationContentAdminControllerUpdateV1 } from '../fn/consultation-content-admin/consultation-content-admin-controller-update-v-1';
import { ConsultationContentAdminControllerUpdateV1$Params } from '../fn/consultation-content-admin/consultation-content-admin-controller-update-v-1';
import { ConsultationContentDto } from '../models/consultation-content-dto';

@Injectable({ providedIn: 'root' })
export class ConsultationContentAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `consultationContentAdminControllerFindAllV1()` */
  static readonly ConsultationContentAdminControllerFindAllV1Path = '/api/v1/consultation-contents/admin';

  /**
   * 상담 콘텐츠 목록 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationContentAdminControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationContentAdminControllerFindAllV1$Response(params?: ConsultationContentAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConsultationContentDto>>> {
    const obs = consultationContentAdminControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 콘텐츠 목록 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationContentAdminControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationContentAdminControllerFindAllV1(params?: ConsultationContentAdminControllerFindAllV1$Params, context?: HttpContext): Observable<Array<ConsultationContentDto>> {
    const resp = this.consultationContentAdminControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ConsultationContentDto>>): Array<ConsultationContentDto> => r.body)
    );
  }

  /** Path part for operation `consultationContentAdminControllerCreateV1()` */
  static readonly ConsultationContentAdminControllerCreateV1Path = '/api/v1/consultation-contents/admin';

  /**
   * 상담 콘텐츠 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationContentAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationContentAdminControllerCreateV1$Response(params: ConsultationContentAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationContentDto>> {
    const obs = consultationContentAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 콘텐츠 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationContentAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationContentAdminControllerCreateV1(params: ConsultationContentAdminControllerCreateV1$Params, context?: HttpContext): Observable<ConsultationContentDto> {
    const resp = this.consultationContentAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsultationContentDto>): ConsultationContentDto => r.body)
    );
  }

  /** Path part for operation `consultationContentAdminControllerFindByIdV1()` */
  static readonly ConsultationContentAdminControllerFindByIdV1Path = '/api/v1/consultation-contents/admin/{id}';

  /**
   * 상담 콘텐츠 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationContentAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationContentAdminControllerFindByIdV1$Response(params: ConsultationContentAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationContentDto>> {
    const obs = consultationContentAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 콘텐츠 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationContentAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationContentAdminControllerFindByIdV1(params: ConsultationContentAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<ConsultationContentDto> {
    const resp = this.consultationContentAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsultationContentDto>): ConsultationContentDto => r.body)
    );
  }

  /** Path part for operation `consultationContentAdminControllerDeleteV1()` */
  static readonly ConsultationContentAdminControllerDeleteV1Path = '/api/v1/consultation-contents/admin/{id}';

  /**
   * 상담 콘텐츠 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationContentAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationContentAdminControllerDeleteV1$Response(params: ConsultationContentAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationContentDto>> {
    const obs = consultationContentAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 콘텐츠 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationContentAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consultationContentAdminControllerDeleteV1(params: ConsultationContentAdminControllerDeleteV1$Params, context?: HttpContext): Observable<ConsultationContentDto> {
    const resp = this.consultationContentAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsultationContentDto>): ConsultationContentDto => r.body)
    );
  }

  /** Path part for operation `consultationContentAdminControllerUpdateV1()` */
  static readonly ConsultationContentAdminControllerUpdateV1Path = '/api/v1/consultation-contents/admin/{id}';

  /**
   * 상담 콘텐츠 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationContentAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationContentAdminControllerUpdateV1$Response(params: ConsultationContentAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationContentDto>> {
    const obs = consultationContentAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 콘텐츠 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationContentAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationContentAdminControllerUpdateV1(params: ConsultationContentAdminControllerUpdateV1$Params, context?: HttpContext): Observable<ConsultationContentDto> {
    const resp = this.consultationContentAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsultationContentDto>): ConsultationContentDto => r.body)
    );
  }

  /** Path part for operation `consultationContentAdminControllerReorderV1()` */
  static readonly ConsultationContentAdminControllerReorderV1Path = '/api/v1/consultation-contents/admin/reorder';

  /**
   * 상담 콘텐츠 순서 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consultationContentAdminControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationContentAdminControllerReorderV1$Response(params: ConsultationContentAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConsultationContentDto>>> {
    const obs = consultationContentAdminControllerReorderV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상담 콘텐츠 순서 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consultationContentAdminControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  consultationContentAdminControllerReorderV1(params: ConsultationContentAdminControllerReorderV1$Params, context?: HttpContext): Observable<Array<ConsultationContentDto>> {
    const resp = this.consultationContentAdminControllerReorderV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ConsultationContentDto>>): Array<ConsultationContentDto> => r.body)
    );
  }

}
